import type {
    QueryKey,
    UseQueryResult,
    UseQueryOptions as _UseQueryOptions,
} from "@tanstack/react-query";
import {
    useQueryClient,
    useQuery as useQueryImpl,
} from "@tanstack/react-query";

export { useQueryClient };

export type UseQueryOptions<
    TQueryFnData = unknown,
    TError = unknown,
    TData = TQueryFnData,
> = {
    namespaceID: number;
} & _UseQueryOptions<TQueryFnData, TError, TData>;

/**
 * Wrapper around useQuery that makes it same to use in our multi-site setup.
 * The `namespaceID` param generally be the Wagtail Site ID. However any
 * non-shared-across-sites ID is acceptable.
 */
export const useQuery = <
    TQueryFnData = unknown,
    TError = unknown,
    TData = TQueryFnData,
>({
    namespaceID,
    ...options
}: UseQueryOptions<TQueryFnData, TError, TData>): UseQueryResult<
    TData,
    TError
> => {
    const naiveQueryKey: QueryKey = options.queryKey || [];
    const safeQueryKey: QueryKey = [namespaceID, ...naiveQueryKey];
    return useQueryImpl({
        ...options,
        queryKey: safeQueryKey,
    });
};
